import { inject } from 'aurelia';
import { IDialogController } from '@aurelia/dialog';
import { AccountActionService } from '../../services/account-action-service';

/**
 * Engångskoden på väg till nya Control (apply-system 0023, tillägg 2026-11-04).
 *
 * Stiftelsen kräver lösenord med engångskod, och inloggningen gjordes med
 * bara lösenord. Apply har skickat en kod till e-posten; rätt kod ger
 * nyckeln till Control, och dialogen stängs med den.
 */
@inject(IDialogController, AccountActionService)
export class ControlCodeDialog {
  code = '';
  invalid = false;
  error = false;
  inProgress = false;
  resent = false;

  constructor(controller, accountActionService) {
    this.controller = controller;
    this.accountActionService = accountActionService;
  }

  activate(model) {
    this.mfaToken = (model && model.mfaToken) || null;
    this.customer = (model && model.customer) || null;
  }

  get canVerify() {
    return Boolean(this.mfaToken && (this.code || '').trim()) && !this.inProgress;
  }

  async verify() {
    if (!this.canVerify) return;
    this.invalid = false;
    this.error = false;
    this.inProgress = true;
    try {
      const requestKey = await this.accountActionService.verifyControlCode(this.mfaToken, this.code.trim());
      this.controller.ok(requestKey);
    } catch (e) {
      if (e && e.statusCode === 401) {
        this.invalid = true;
        return;
      }
      this.error = true;
    } finally {
      this.inProgress = false;
    }
  }

  /** En ny kod: samma anrop som öppnade dialogen, som skickar en ny. */
  async resend() {
    this.invalid = false;
    this.error = false;
    this.resent = false;
    this.inProgress = true;
    try {
      const answer = await this.accountActionService.create('control', this.customer);
      if (answer && answer.next === 'otp_required' && answer.mfa_token) {
        this.mfaToken = answer.mfa_token;
        this.code = '';
        this.resent = true;
        return;
      }
      /* Nivån räckte nu ändå, till exempel efter en ny inloggning i en annan flik. */
      if (answer && answer.requestKey) this.controller.ok(answer.requestKey);
    } catch {
      this.error = true;
    } finally {
      this.inProgress = false;
    }
  }

  cancel() {
    this.controller.cancel();
  }
}
